import { useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import SiteCard from "../sites/SiteCard";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";
import SiteDropDownInput from "../employees/SiteDropDownInput";
import MaterialInput from "../../../helperComponents/MaterialInput";
import VacationCard from "../vacation/VacationCard";

export default function NomenclatureOfVacation({
  userID,
  disableFilters,
  inheritedSearchQuery,
  callback,
  onlyForThisMonth,
  title,
}) {
  const [zoneID, setZoneID] = useState(null);
  const [siteID, setSiteID] = useState(null);
  const [date, setDate] = useState(null);

  if (onlyForThisMonth) title = "Congés du mois ci";

  return (
    <ContentList
      callback={callback}
      disableFilters={onlyForThisMonth ? true : disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      userID={userID}
      doReset={() => {
        setZoneID(null);
        setSiteID(null);
        setDate(null);
      }}
      permissionName={"vacationPermissions"}
      queryParams={{ zoneID, siteID, date, onlyForThisMonth }}
      filters={
        <>
          <MaterialInput
            type="date"
            label={"Date"}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
          <SiteDropDownInput onChange={setSiteID} value={siteID} label="Site" />
          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />
        </>
      }
      title={title ? title : "Conges"}
      path="vacations"
      CardComponent={VacationCard}
    />
  );
}
